<template>
  <div class="form-group" v-bind:style="changedOrder?{order: -1}:undefined">
    <CustomSelect name="product" @initialize="onInitialize" @itemSelected="onItemSelected">
      <option data-component="PremierInvest" value="PremierInvest">Премьер Инвест</option>
      <option data-component="PremierInvest" value="PremierFuture">Премьер Будущее</option>
      <option data-component="PremierLife" value="PremierLife">Премьер Лайф</option>
    </CustomSelect>
  </div>

  <component :is="premierInsuranceComponent"></component>
</template>

<script>
import * as mns from "@/store/mutation-types";
import {mapGetters} from "vuex";
import PremierInvest from "@/components/insurances/PremierInvest/PremierInvest";
import CustomSelect from "@/components/utils/CustomSelect";
import PremierLife from "@/components/insurances/PremierLife/PremierLife";

export default {
  name: "PremierInsurance",
  components: {
    PremierInvest, PremierLife, CustomSelect,
  },
  props: {
    changedOrder: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInitialize(event){
      this.$store.commit(mns.SET_INSURANCE_PRODUCT, event.getValue().value);
      this.$store.commit(mns.SET_PREMIER_INSURANCE_COMPONENT, event.getValue().customProperties.component);
    },
    onItemSelected(event){
      const choice = event.detail.choice;

      this.$store.commit(mns.SET_INSURANCE_PRODUCT, choice.value);
      this.$store.commit(mns.SET_PREMIER_INSURANCE_COMPONENT, choice.customProperties.component);
    },
  },
  computed: {
    ...mapGetters(['premierInsuranceComponent']),
  }
}
</script>

<style scoped>

</style>